import * as R from 'ramda'
import React from 'react'

import { ParticipantType, ServiceType } from '../../services/Model/Activity'
import { CompletionStatus, CompletionStatusItems, ParticipantOutcome } from '../../services/Model/Outcome'

export const getOutcomesAccordingToStatus = (statusValue: string, outcomes: ParticipantOutcome) => {
	const status = CompletionStatusItems.find((i) => i.label === statusValue)
	const completionStatus = status && status.value ? CompletionStatus[status!.value] : null

	if (completionStatus === CompletionStatus.ENROLLED) {
		return {
			...outcomes,
			completionStatus,
			dropReason: null,
			completionDate: null
		}
	} else {
		return { ...outcomes, completionStatus: status && status.value ? CompletionStatus[status!.value] : null }
	}
}

export const validateForm = (ref: React.RefObject<HTMLFormElement>) => {
	const form = ref.current

	return form && form.reportValidity()
}

// TODO - add generic props or add prop type for all forms
export const setInitialState = (props: any) => {
	return {
		localOutcomes: props.outcomes,
	}
}

export const renderOnServiceAndActivityType = (participantType: ParticipantType, serviceType: ServiceType) => {
	const validScenarios = [
		{
			serviceType: ServiceType.CAREER_EXPLORATION_ESSENTIAL_SKILLS,
			participantType: ParticipantType.NON_ENROLLED,
		}
	]
	const pred = R.whereEq({ participantType, serviceType })

	return R.any(pred, validScenarios)
}

